import { render, staticRenderFns } from "./ModalConfirmPasteImage.vue?vue&type=template&id=37fc5dc2&"
import script from "./ModalConfirmPasteImage.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmPasteImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports